import { stardust } from '@eidellev/adonis-stardust/client';
import { getPageLang } from '../modules/utils';

document.addEventListener('DOMContentLoaded', async () => {
  const module = document.querySelector('.rlx-watch-grid');

  if (!module) {
    return;
  }

  const watchGrid = module.querySelector('.js-watch-grid') as HTMLElement;

  const loadMore = module.querySelector('.js-rlx-load-more-watches') as HTMLInputElement;

  const states = {
    IDLE: 0,
    WORKING: 1,
    DONE: 2,
  };

  let state = states.IDLE;
  let currentPage = 1;

  loadMore?.addEventListener('click', (e) => {
    e.preventDefault();
    getNextPage();
  });

  async function getNextPage() {
    if (state === states.WORKING) {
      return;
    }

    const family = watchGrid.dataset.family;

    const fetchUrl = stardust.route('api.rolex.watches', undefined, { qs: {
      page: currentPage + 1,
      family,
      lang: getPageLang(),
    } });

    const { html, moreWatches } = await fetch(fetchUrl).then((r) => {
      currentPage++;

      return r.json();
    });

    const itemsToAppend = html.map(createElementFromHTML);

    watchGrid.append(...itemsToAppend);

    fadeInWatches();

    if (!moreWatches) {
      loadMore.setAttribute('aria-hidden', 'true');
      loadMore.disabled = true;

      state = states.DONE;
    }
  }

  function fadeInWatches() {
    let newPosts = watchGrid?.querySelectorAll(
      '.rlx-watch-card--hidden',
    );

    window.setTimeout(function() {
      newPosts?.forEach((post) => {
        post.classList.remove('rlx-watch-card--hidden');
      });
    }, 100);
  }
});

function createElementFromHTML(htmlString: string): HTMLElement {
  const div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  return div.firstChild as HTMLElement;
}

// function formatWatches(watches) {
//   return watches.map((watch) => {
//     let div = document.createElement('div');
//     div.classList.add(
//       'archive__grid-item',
//       'archive__grid-item--hidden',
//     );

//     div.innerHTML = post;

//     return div;
//   });
// }
